import { TypedError } from '@rehaje/errors'

import { FatalCycleError } from './FatalCycleError'
import {
  FatalDecoratorExistedError,
  FatalDecoratorLimitClassError,
  FatalDecoratorLimitDescriptorError,
  FatalDecoratorLimitGetterError,
  FatalDecoratorLimitMethodError,
  FatalDecoratorLimitSetterError,
  FatalDecoratorNotSupportError
} from './FatalDecoratorError'

export * from './FatalCycleError'
export * from './FatalDecoratorError'

export function registerErrorsSideEffect() {
  TypedError.registerErrorLocales({
    FatalCycleError,
    FatalDecoratorExistedError,
    FatalDecoratorLimitClassError,
    FatalDecoratorLimitDescriptorError,
    FatalDecoratorLimitGetterError,
    FatalDecoratorLimitMethodError,
    FatalDecoratorLimitSetterError,
    FatalDecoratorNotSupportError
  })
}

registerErrorsSideEffect()
